<script setup>
    import { useSpaceStore } from "~/stores"

    const spaceStore = useSpaceStore()
</script>

<template>
    <v-footer app>
        <a class="white--text">
            Politique de Confidentialité - Mentions légales</a
        >
        <span class="white--text">
            {{ spaceStore.contacts?.CUSTOMER?.name }}</span
        >
    </v-footer>
</template>

<style scoped>
    .v-footer {
    text-align: center;
    padding: 10px;
    display: flex;
    justify-content: space-between;
}

.v-footer > * {
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    font-weight: 300;
    text-align: right;
}

.v-footer a:hover {
    text-decoration: underline;
}
</style>
